import { isNullOrUndefined } from "util";

export const formatDate = (date, isTimeReq) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    var hour = d.getHours(), minutes = d.getMinutes(), seconds = d.getSeconds();
    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    if(isTimeReq){
        let dateLevel = [year, month, day].join('-');
        let timeLevel = [hour, minutes, seconds].join(':');
        return (dateLevel+ " " + timeLevel)
    }
    return [year, month, day].join('-');
}

export const getMeetingAttendeesString = (attendees) => {
    let ans = "";
    if(!isNullOrUndefined(attendees)){
        for(let i=0; i<attendees.length; i++){
            ans += attendees[i];
            if(i<attendees.length-1){
                ans += ", ";
            }
        }
    }
    return ans;
}

export const getMeetingSourceActivityString = (meetingActivity, source) => {
    let ans = "";
    if(!isNullOrUndefined(meetingActivity) && !isNullOrUndefined(source)
    && ('link' in source)){
        for(let key in meetingActivity){
            if(meetingActivity[key].link == source.link && 
                (Date.now() - meetingActivity[key].ts < 30*60*1000)){
                ans += meetingActivity[key].userId.trim();
                ans += ", ";
            }            
        }
        if(ans.length>2){
            ans = ans.substr(0,ans.length-2);
        }
    }
    return ans;
}

export const getShaKey = (str) => {
    var shajs = require('sha.js');
    let key = shajs('sha256').update(str).digest('hex');
    return key;
}

const setSpaceFlagForExtraLines = (char) => {
    if(char == ' ')
        return 1;
    if(char == '\n')
        return 2;
}

export const removeExtraLineSpaceFromText = (str) => {
    let ans = "";
    for(let i=0; !isNullOrUndefined(str) && i<str.length;i++){
        let shouldRetain = true;
        if(i>0){
            let fl1=0, fl2=0, fl0=0;
            fl0 = setSpaceFlagForExtraLines(str[i-1]);
            fl1 = setSpaceFlagForExtraLines(str[i]);
            if(i<str.length-1)
                fl2 = setSpaceFlagForExtraLines(str[i+1]);

            //Two '\n' before and after
            if(fl0==2 && fl2==2 && fl1>0)
                shouldRetain = false;

            //Two consecitive ' ' 
            if(fl0==1 && fl1==1)
                shouldRetain = false;
        }

        if(shouldRetain){
            ans += str[i];
        }
    }
    ans = ans.trim();
    return ans;
}

const checkIfWikipedia = (result) => {
    let link = result.link;
    let title = result.title;
    if(!isNullOrUndefined(link) && !isNullOrUndefined(title)){
        if(link.includes('wikipedia') && title.includes('Wikipedia'))
            return true;
    }
    return false;
}

const checkIfWikipediaInList = (results, output) => {
    for(let i=0; !isNullOrUndefined(results) && i<results.length;
    i++)
    {
        let currResult = results[i];
        if(checkIfWikipedia(currResult)){
            output.push({
                'link': currResult.link,
                'title': currResult.title
            });
        }
        if('sitelinks' in currResult){
            for(var x in currResult['sitelinks']){
                checkIfWikipediaInList(currResult['sitelinks'][x])
            }
        }
    }
}

export const getWikipediaLinks = (googleSearchRes) => {
    let output = [];
    if('organic_results' in googleSearchRes){
        let results = googleSearchRes['organic_results'];
        checkIfWikipediaInList(results,output);    
    }
    if('answer_box' in googleSearchRes){
        let results = [googleSearchRes['answer_box']];
        checkIfWikipediaInList(results,output);  
    }
    return output;
}

export const capitalizeFirstLetter = (string) => {
    if(!isNullOrUndefined(string) && string.length>0)
        return string.charAt(0).toUpperCase() + string.slice(1);
    return string;
  }

export const breakStringAfterScraping = (str, delim) => {
    if(isNullOrUndefined(str) || isNullOrUndefined(delim))
        return str;
    let newStr = "";
    for(let i=0; i<str.length; i++){
        if((str[i]>='A' && str[i]<='Z') && i>0 && 
        ((str[i-1]==')') || (str[i-1]>='a' && str[i-1]<='z'))){
            newStr += delim;
        }
        newStr += str[i];
    }
    return newStr;
}

export const getSentences = (text) => {
 
    if(isNullOrUndefined(text))
        return [];

    // Search for sentences, insert a pipe, then split on the pipe
    let sentenceArray = text.replace(/([.?!])\s*(?=[A-Z])/g, "$1|").split("|")
    return sentenceArray;
}

export const dedupArrayOnKey = (arr, key) => {
    if(isNullOrUndefined(arr) || isNullOrUndefined(key)){
        return [];
    }
    let existingKeys = {};
    let output = [];
    for(let i=0; i<arr.length; i++){
        let element = arr[i];
        // console.log(element);
        if(!isNullOrUndefined(element) && key in element && !(element[key] in existingKeys)){
            existingKeys[element[key]] = true;
            output.push(element);
        }
    }
    return output;
}

export const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const cleanString = (input) => {
    var output = "";
    for (var i=0; i<input.length; i++) {
        if (input.charCodeAt(i) <= 127) {
            output += input.charAt(i);
        }
    }
    return output;
}